import { render, staticRenderFns } from "./Radio.vue?vue&type=template&id=0be38bcc&scoped=true"
import script from "./Radio.vue?vue&type=script&lang=js"
export * from "./Radio.vue?vue&type=script&lang=js"
import style0 from "./Radio.css?vue&type=style&index=0&id=0be38bcc&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be38bcc",
  null
  
)

export default component.exports